module.exports = __webpack_public_path__ + "img/banner-42-light.89f7ac1f.jpg";